import clsx from 'clsx'
import type { ReactElement } from 'react'
import { profileColorClasses } from '~/styles/profileColors.css'
import { getProfileColorIndex } from '~/utils/profileColors'
import { inner, wrapper, wrapperInversed } from './NameCircle.css'

interface NameCircleProps {
  name: string
  size?: number
  inversedTheme?: boolean
}

export const NameCircle = ({
  name,
  inversedTheme = false,
  size = 35
}: NameCircleProps): ReactElement => {
  const names = name.split(' ').slice(0, 2)
  let initials = ''
  if (names.length === 0) {
    initials = 'NR'
  } else {
    for (const name of names) {
      initials += name[0]?.toUpperCase() ?? ''
    }
  }

  return (
    <span
      className={clsx(
        wrapper,
        inversedTheme
          ? wrapperInversed
          : profileColorClasses[getProfileColorIndex(initials)]
      )}
    >
      <span
        className={clsx(inner)}
        style={{
          height: size,
          minWidth: size,
          width: size
        }}
      >
        {initials}
      </span>
    </span>
  )
}
